import { useEffect } from "react";
import { motion, useMotionValue, useSpring } from "framer-motion";

export default function Wallpaper() {
  const mx = useMotionValue(0);
  const my = useMotionValue(0);
  const x = useSpring(mx, { stiffness: 42, damping: 16 });
  const y = useSpring(my, { stiffness: 42, damping: 16 });

  useEffect(() => {
    const onMove = (e) => {
      mx.set((e.clientX / window.innerWidth - 0.5) * -20);
      my.set((e.clientY / window.innerHeight - 0.5) * -14);
    };
    window.addEventListener("pointermove", onMove);
    return () => window.removeEventListener("pointermove", onMove);
  }, [mx, my]);

  return (
    <motion.div className="absolute inset-0 overflow-hidden" style={{ x, y, scale: 1.07 }} data-testid="wallpaper">
      <img src="/wallpaper.jpg" alt="" className="h-full w-full object-cover" draggable={false} />
      <div className="absolute inset-0 bg-gradient-to-b from-[#0b0f17]/75 via-[#0b0f17]/40 to-[#0b0f17]/85" />
    </motion.div>
  );
}
